<div *ngIf="carregandoConteudo$ | async" class="div-cabecalho-loading"></div>
<div
  class="div-cabecalho"
  *ngIf="!(carregandoConteudo$ | async)"
  [ngClass]="{ shadow: indexLinhaAtual != 0 }"
>
  <div class="div-esquerda-cabecalho">
    <a
      [href]="urlFonteLei"
      target="_blank"
      rel="noopener noreferrer"
      title="Fonte"
    >
      <mat-icon matTooltip="Ir para a fonte do documento" class="fonte-icone"
        >public</mat-icon
      >
    </a>
    <div class="noselect div-cabecalho-titulo" [title]="tituloAtual">
      <span style="display: inline-flex; margin-top: -4px; line-height: 2">
        {{
          (tituloAtual?.length > 75
            ? tituloAtual?.substring(0, 75) + "..."
            : tituloAtual) ?? ""
        }}
      </span>
    </div>
  </div>
  <div class="div-direita-cabecalho">
    <button
      mat-icon-button
      class="mat-small"
      aria-label="Alterar favorito"
      (click)="favoritoAlterardo()"
    >
      <mat-icon
        class="icone-cabecalho-favorito"
        aria-label="Favoritar lei"
        matTooltip="Favoritar lei"
        [svgIcon]="isfavorito ? 'star' : 'star-bord'"
      ></mat-icon>
    </button>

    <app-form-busca-artigo-documento-atual
      class="cabecalho-artigo-documento-atual"
      [prefixoBusca]="prefixoBusca"
      [tooltipBusca]="tooltipBusca"
    >
    </app-form-busca-artigo-documento-atual>
    <button
      mat-icon-button
      class="mat-small"
      title="Ir para o começo"
      color="primary"
      (click)="ArtigoInicial()"
    >
      <mat-icon
        *ngIf="!(carregandoConteudo$ | async)"
        class="icone-cabecalho"
        aria-label="Ir para o começo do documento"
        matTooltip="Ir para o começo do documento"
        >first_page</mat-icon
      >
    </button>
    <button
      mat-icon-button
      class="mat-small"
      title="Ir para o final"
      color="primary"
      (click)="ArtigoFinal()"
    >
      <mat-icon
        *ngIf="!(carregandoConteudo$ | async)"
        mat-icon-button
        class="icone-cabecalho"
        aria-label="Ir para o final do documento"
        matTooltip="Ir para o final do documento"
        >last_page</mat-icon
      >
    </button>

    <button
      mat-icon-button
      class="mat-small"
      title="Painel de configuração"
      color="primary"
      (click)="openDialog()"
    >
      <mat-icon
        *ngIf="!(carregandoConteudo$ | async)"
        class="icone-cabecalho-v"
        aria-label="Painel de configuração"
        matTooltip="Painel de configuração"
        >settings</mat-icon
      >
    </button>
  </div>
</div>
